// Dependencias generales
import React from "react";
import { useEffect } from 'react';

const SharedUsers = (params) => {

  useEffect(() => {    
    console.log("Listado de usuarios compartidos cargado correctamente.")
  }, []);

  const listUsers = params.listadoUsuariosCompartidos.map((user) =>
    
    [ !user.ACCOUNT_ID.includes("@") && (user.UserFullName !== "")?
    <React.Fragment key={user.ACCOUNT_ID}>
    
      <li className="list-item">
        <figure className="avatar size-l pink"><span className="material-icon">person</span></figure>
        <div className="content">
          <span className="value">{user.UserFullName}</span>
          <span className="label">{user.UserEmail}</span>
        </div>
        <button className="link delete" onClick={() => params.dejarDeCompartirInstalacion(user.INSTALLATION_ID, user.ACCOUNT_ID, "")}><span className="material-icon">remove_circle</span></button>
      </li>

    </React.Fragment>
    :
    <React.Fragment key={user.ACCOUNT_ID}>
    
      <li className="list-item">
        <figure className="avatar size-l pink"><span className="material-icon">person</span></figure>
        <div className="content">
          <span className="value">{user.ACCOUNT_ID} </span>         
          <span className="label">Este usuario todavía no ha accedido nunca a HELIAS</span> 
        </div>
        <button className="link delete" onClick={() => params.dejarDeCompartirInstalacion(user.INSTALLATION_ID, user.ACCOUNT_ID, "")}><span className="material-icon">remove_circle</span></button>
      </li>

    </React.Fragment>
    ]
  );    

  return (       
    
    <>      
      <ul className="list with-dividers">

        {listUsers}

      </ul>
    </>
  )
}

export default SharedUsers